(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('DiagnosesHistoryNewController', DiagnosesHistoryNewController);

    DiagnosesHistoryNewController.$inject = ['Diagnoses', 'DTOptionsBuilder', 'DTColumnBuilder', 'DataTablesService',
                                             'chart', '$uibModalInstance', '$timeout'];

    function DiagnosesHistoryNewController(Diagnoses, DTOptionsBuilder, DTColumnBuilder, DataTablesService,
                                           chart, $uibModalInstance, $timeout) {
        var vm = this;
        vm.chart = chart;

        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.diagnoses = [];

        vm.clear = clear;
        vm.search = search;
        vm.transition = transition;

        loadAll();

        function loadAll() {
            Diagnoses.findAllByChart(getFilter(), function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.diagnoses = result;
            });
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function getFilter() {
            var filter = {};

            filter.chartId = vm.chart.id;
            filter.active = false;
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.searchQuery = vm.searchQuery;

            return filter
        }

        function search() {
            vm.page = 1;
            loadAll();
        }

        function transition() {
            loadAll();
        }
    }
})();
